import styled from 'styled-components';

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;

    --color__accent: #f20a0a;

    --field__background: #f5f5f57d;
    --field__background--hover: #e9e9e9;
    --input__border: rgba(0, 0, 0, 0.42);
    --input__border--hover: rgba(0, 0, 0, 0.62);
    --label__color: #222;

    --font__size: 12px;
    --font__family: var(--page-font-family);
  

  button{
    background: #e6000f;
    font-weight: 600;
    border-radius: 24px;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-align-items: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    text-align: center;
    letter-spacing: 0.3px;
    border: 0;
    color: white;
    outline: 0;
    padding: 8px 0;
    font-size: 12px;
    line-height: 20px;
    width: 100%;
    cursor: pointer;
    max-width: 160px;
    -webkit-transition: 0.2s;
    transition: 0.2s;
    float: right;
  }
  button:hover{
    box-shadow: 0 6px 8px rgb(230 0 15 / 30%);
  }
  form{
    width: 100%;
    position: relative;
    margin: 30px auto 0 auto;
  }
  .row{
    width: 100%;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px,1fr));
    grid-gap: 20px 30px;
    margin-bottom: 20px;
  }
  textarea{
    resize: none;
      color: inherit;
      -webkit-appearance: none;
      outline: 0;
      height: 200px;
      box-sizing: border-box;
      width: 100%;
      font-size: 14px;
      padding: 2rem 1rem 0.6rem!important;
      background: var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box;
      border: none!important;
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
      outline:none!important;
    
    }
  .errorText {
    display: flex;
    font-size:14px;
    color:red;
    justify-content: end;
    margin-bottom: 10px;
    animation: fade .5s cubic-bezier(0.165, 0.840, 0.440, 1.000) forwards;
  }
  @keyframes fade {
    0% {
      transform: translate3d(0, -50px, 0);
      opacity:0;
    }
    100% {
      transform: translate3d(0, 0, 0);
      opacity:1;
    }
  }
  .result{
    padding: 48px 32px;
  }
  .result-title{
    color: rgba(0, 0, 0, 0.88);
    font-size: 14px;
    line-height: 1.3333333333333333;
    margin-block: 8px;
    text-align: center;
  }
  .result-subtitle{
    color: rgb(0 0 0 / 78%);
    font-size: 14px;
    line-height: 1.5714285714285714;
    text-align: center;
  }
  .result-icon{
    align-items: center;
    display: flex;
    justify-content: center;
  }
  .floating {
    margin-bottom: 1rem;
    background-color: var(--field__background);
    transition: background-color 0.2s ease;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }

  .floating:hover,
  .floating:focus-within {
    background-color: var(--field__background--hover);
  }

  .floating__input {
    padding: 1.5rem 1rem 0.6rem;
    font-size: 14px;
    border: 0.5px solid rgb(0 0 0 / 5%);
    transition: border-color 0.2s ease;
    caret-color: var(--color__accent);
    outline: none;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }

  .floating:hover .floating__input {
    border-color: transparent;
  }

  .floating__input::placeholder {
    color: rgba(0, 0, 0, 0);
  }
    input {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      background: transparent;
      caret-color: var(--accent-color);
      border: 1px solid transparent;
      border-bottom-color: rgba(0, 0, 0, 0.42);
      color: rgba(0, 0, 0, 0.87);
      transition: border 500ms;
      padding: 20px 16px 6px;
      font-size: 1rem;
    }
  .floating__label {
    display: block;
    position: relative;
    max-height: 0;
    font-weight: 500;
    pointer-events: none;
    font-size: 14px;
  }

  .floating__label::before {
    color: var(--label__color);
    content: attr(data-content);
    display: inline-block;
    filter: blur(0);
    backface-visibility: hidden;
    transform-origin: left top;
    transition: transform 0.2s ease;
    left: 1rem;
    position: relative;
  }
  .hidden--visually {
    border: 0;
    clip: rect(1px 1px 1px 1px);
    clip: rect(1px, 1px, 1px, 1px);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
  }
  .floating__label::after {
    bottom: 1rem;
    content: "";
    height: 0.1rem;
    position: absolute;
    transition: transform 180ms cubic-bezier(0.4, 0, 0.2, 1),
    opacity 180ms cubic-bezier(0.4, 0, 0.2, 1), background-color 0.3s ease;
    opacity: 0;
    left: 0;
    top: 100%;
    margin-top: -0.1rem;
    transform: scale3d(0, 1, 1);
    width: 100%;
    background-color: var(--color__accent);
  }

  .floating__input:focus + .floating__label::after {
    transform: scale3d(1, 1, 1);
    opacity: 1;
  }

  .floating__input:placeholder-shown + .floating__label::before {
    transform: translate3d(0, -2.2rem, 0) scale3d(1, 1, 1);
  }

  .floating__label::before,
  .floating__input:focus + .floating__label::before {
    transform: translate3d(0, -3.12rem, 0) scale3d(0.82, 0.82, 1);
  }

  .floating__input:focus + .floating__label::before {
    color: var(--color__accent);
  }
  .floating__label_textarea {
    display: block;
    position: relative;
    max-height: 0;
    font-weight: 500;
    pointer-events: none;
    font-size: 14px;
  }

  .floating__label_textarea::before {
    color: var(--label__color);
    content: attr(data-content);
    display: inline-block;
    filter: blur(0);
    backface-visibility: hidden;
    transform-origin: left top;
    transition: transform 0.2s ease;
    left: 1rem;
    bottom:9rem;
    position: relative;
  }
  .floating__label_textarea::after {
    bottom: 1rem;
    content: "";
    height: 0.1rem;
    position: absolute;
    transition: transform 180ms cubic-bezier(0.4, 0, 0.2, 1),
    opacity 180ms cubic-bezier(0.4, 0, 0.2, 1), background-color 0.3s ease;
    opacity: 0;
    left: 0;
    top: 100%;
    margin-top: -0.1rem;
    transform: scale3d(0, 1, 1);
    width: 100%;
    background-color: var(--color__accent);
  }
  .floating__input:focus + .floating__label_textarea::after {
    transform: scale3d(1, 1, 1);
    opacity: 1;
  }

  .floating__input:placeholder-shown + .floating__label_textarea::before {
    transform: translate3d(0, -2.2rem, 0) scale3d(1, 1, 1);
  }

  .floating__label_textarea::before,
  .floating__input:focus + .floating__label_textarea::before {
    transform: translate3d(0, -3.12rem, 0) scale3d(0.82, 0.82, 1);
  }

  .floating__input:focus + .floating__label_textarea::before {
    color: var(--color__accent);
  }
  .h-300{
    height:250px;
  }
  .h-100{
    height:100px;
  }

`;

